import { gql } from "@apollo/client";

const PersonQuery = gql`
  query Person($user_token: String!) {
    staffing_partner_contractor_details(user_token: $user_token) {
      id
      full_name
      first_name
      last_name
      preferred_full_name
      token
      phone_number
      email
      profile_picture_url(size: 128)
      personal_information {
        id
        phone
        full_address
        preferred_first_name
        preferred_or_legal_firstname
        preferred_full_name
        firstname
        lastname
        street
        city
        state
        zip
      }
      employer_onboardings(staffing_agency_eor: true) {
        id
        token
        job {
          id
          name
        }
        complete
        display_start_date
        display_end_date
        bill_rate
        pay_rate
        pay_rate_access
        has_screening_requirements
        hireart_employer_of_record
        isFailedScreeningResolved
        isOnboardingPaused
        all_failed_requirements_accepted
        is_payment_info_complete
        get_substatus
        employer_of_record
        offer {
          id
          start_date
          employer_start_date
          work_location
          employer_other_pay_rate
          pay_rate
          pay_rate_prefix
          salary
          salary_prefix
          revoked_at
          rejected_at
          usesOffPlatformNegotiations
        }
        assignment {
          id
          token
          active
          terminated
          wage
          salary
          start_date
          end_date
          status
          pto_available
          token
          title
          pay_display
          work_location
          hours_worked_stats
          employer_of_record
          job {
            id
            employer {
              id
              name
            }
          }
          current_pay_rate_history {
            amount
            started_at
          }
          user {
            id
            pto_eligible
          }
          termination_requests {
            id
            is_employee_notified
            reason
            severance_terms
            severance_payment_amount
            severance_agreement_signature_required
            ha_to_facilitate_equipment_return
            equipment_return_instructions
            is_time_sensitive
            termination_time_instructions
            effective_date
            other_notes
            status
          }
          current_direct_manager {
            id
            token
            full_name
            profile_picture_url
          }
          all_current_managers_at_employer {
            id
            token
            full_name
            email
          }
        }
      }
    }
  }
`;

export default PersonQuery;
